import request from '@/utils/request'

// 获取所有配置
export function getConfigs() {
    return request({
        url: '/admin/configs',
        method: 'get'
    })
}

// 获取配置类型列表
export function getConfigTypes() {
    return request({
        url: '/admin/configs/types',
        method: 'get'
    })
}

// 根据ID获取配置
export function getConfigById(id) {
    return request({
        url: `/admin/configs/${id}`,
        method: 'get'
    })
}

// 创建配置
export function createConfig(data) {
    return request({
        url: '/admin/configs',
        method: 'post',
        data
    })
}

// 更新配置
export function updateConfig(id, data) {
    return request({
        url: `/admin/configs/${id}`,
        method: 'put',
        data
    })
}

// 删除配置
export function deleteConfig(id) {
    return request({
        url: `/admin/configs/${id}`,
        method: 'delete'
    })
}

// 刷新配置缓存
export function refreshConfigCache() {
    return request({
        url: '/admin/configs/refresh-cache',
        method: 'post'
    })
}